import { thirdPartyWithLayoutService } from '@bedrock/fido-sdk';

export const startEngines = async (acceptedEngines, rejectedEngines) => {
  await thirdPartyWithLayoutService.initThirdPartyEngines(acceptedEngines);
  thirdPartyWithLayoutService.rejectThirdPartyEngines(rejectedEngines);
};

export const stopEngines = () => {};
